import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private titleService: Title, private metaService: Meta) { }

  updateMetaTags(title: string, description?: string, keywords?: string) {
    this.titleService.setTitle(title);

    if (description) {
      this.metaService.updateTag({ name: 'description', content: description });
      this.metaService.updateTag({ property: 'og:description', content: description });
      this.metaService.updateTag({ name: 'twitter:description', content: description });
    }

    if (keywords) {
      this.metaService.updateTag({ name: 'keywords', content: keywords });
    }

    this.metaService.updateTag({ property: 'og:title', content: title });
    this.metaService.updateTag({ name: 'twitter:title', content: title });
  }

  updateCanonicalUrl(url: string) {
    const head = document.getElementsByTagName('head')[0];
    let element: HTMLLinkElement | null = document.querySelector(`link[rel='canonical']`);
    if (!element) {
      element = document.createElement('link') as HTMLLinkElement;
      element.setAttribute('rel', 'canonical');
      head.appendChild(element);
    }
    element.setAttribute('href', url);
    this.metaService.updateTag({ property: 'og:url', content: url });
    this.metaService.updateTag({ name: 'twitter:url', content: url });
  }

  updateOgImage(imageUrl: string, alt?: string) {
    this.metaService.updateTag({ property: 'og:image', content: imageUrl });
    this.metaService.updateTag({ name: 'twitter:image', content: imageUrl });
    if (alt) {
      this.metaService.updateTag({ property: 'og:image:alt', content: alt });
      this.metaService.updateTag({ name: 'twitter:image:alt', content: alt });
    }
  }

  setJsonLd(data: object) {
    const head = document.getElementsByTagName('head')[0];
    const existing = head.querySelector('script[type="application/ld+json"][data-dynamic]');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.setAttribute('data-dynamic', 'true');
    script.textContent = JSON.stringify(data);
    head.appendChild(script);
  }
}
